import type { ReactElement } from 'react';

export type Tab = 'dashboard' | 'grids' | 'generator' | 'stats' | 'method';

/**
 * Icons are inline SVG rather than emoji or box-drawing characters: those render
 * differently on every iOS version and at least one of them lands as a coloured
 * glyph the size of a stamp.
 */
const ICONS: Record<Tab, ReactElement> = {
  dashboard: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="2.6" fill="currentColor" stroke="none" />
    </>
  ),
  grids: (
    <>
      <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" />
      <path d="M3.5 9.5h17M3.5 14.5h17M9 4.5v15" />
    </>
  ),
  generator: (
    <>
      <circle cx="7" cy="7" r="1.9" fill="currentColor" stroke="none" />
      <circle cx="17" cy="7" r="1.9" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.9" fill="currentColor" stroke="none" />
      <circle cx="7" cy="17" r="1.9" fill="currentColor" stroke="none" />
      <circle cx="17" cy="17" r="1.9" fill="currentColor" stroke="none" />
    </>
  ),
  stats: (
    <>
      <path d="M4 20V13M9.33 20V9M14.67 20v-6M20 20V6" />
    </>
  ),
  method: (
    <>
      <path d="M6 4.5h9.5L19 8v11.5H6z" />
      <path d="M9.5 12h6M9.5 15.5h4" />
    </>
  ),
};

const TABS: readonly { id: Tab; label: string }[] = [
  { id: 'dashboard', label: 'Tirages' },
  { id: 'grids', label: 'Grilles' },
  { id: 'generator', label: 'Générateur' },
  { id: 'stats', label: 'Statistiques' },
  { id: 'method', label: 'Méthode' },
];

interface BottomNavProps {
  active: Tab;
  onChange: (tab: Tab) => void;
}

export function BottomNav({ active, onChange }: BottomNavProps): ReactElement {
  return (
    <nav className="nav" aria-label="Navigation principale">
      {TABS.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          aria-current={active === t.id ? 'page' : undefined}
        >
          <svg
            className="glyph"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            {ICONS[t.id]}
          </svg>
          {t.label}
        </button>
      ))}
    </nav>
  );
}

export const TAB_IDS: readonly Tab[] = TABS.map((t) => t.id);
